<template lang="pug">
  footer.TheFooter
    .page-container
      .left-wrap
        FormSubscribeNewsletter(v-if="isMounted && !__prerender",)
        TheFooterMenu(v-bind="menu")
      .right-wrap
        ul.location.mb-0(
          itemscope,
          itemtype="https://schema.org/Organization",
        )
          li
            a.link-1(
                :href="`mailto:${CONTACTS.email}`"
              )
              SolidEnvelopeIcon.svg-icon.envelope-icon
              span(itemprop="email") {{ CONTACTS.email }}
          li
            a.link-1(
                :href="`tel:${CONTACTS.phone}`"
              )
              SolidPhoneIcon.svg-icon.phone-icon
              span(itemprop="telephone") {{ CONTACTS.phone }}
          li.d-none
            span(itemprop="address") {{ CONTACTS.streetAddress }},
              |  {{ CONTACTS.addressLocality }},
              |  {{ CONTACTS.addressRegion }} {{ CONTACTS.postalCode }}
          p.d-none(itemprop="description") AcreTrader is a real estate investing platform
            |  that makes it easy to buy shares of farmland and earn passive income,
            |  starting with as little as $3,000.
        ul.location.mt-0(
          itemscope,
          itemtype="https://schema.org/PostalAddress",
        )
          li
            a.link-1.address(
                :href="`${CONTACTS.mapLink}`",
                target="_blank"
              )
              SolidMapMarkerAltIcon.svg-icon.map-marker-alt-icon
              span
                span(itemprop="streetAddress") {{ CONTACTS.streetAddress }},
                span(itemprop="addressLocality")  {{ CONTACTS.addressLocality }},
                span(itemprop="addressRegion")  {{ CONTACTS.addressRegion }}
                span(itemprop="postalCode")  {{ CONTACTS.postalCode }}
        TheFooterSocialLinks
    .footer-bottom
      v-container(grid-list-lg)
        v-layout(row wrap)
          v-flex(xs12 footer-bottom-wrap)
            p.mb-0.small-text.footer-text AcreTrader, Inc. is not a registered broker-dealer,
              |  investment adviser, or crowdfunding portal under Regulation CF. None of the
              |  information contained on this website is a recommendation to invest in any
              |  securities. Please consult with your legal and financial advisors before
              |  investing and do not invest unless you are able to sustain the risk of loss
              |  of your entire investment. By using this website, you accept our&nbsp;
              router-link(:to="{ name: 'terms' }") Terms of Use
              | &nbsp;and&nbsp;
              router-link(:to="{ name: 'privacy' }") Privacy Policy.
              |  Past performance is no guarantee of future results. Any historical returns,
              |  expected returns, or probability projections are forward looking statements
              |  and may not reflect actual future performance. All investments involve risk
              |  and may result in loss. For more information read our&nbsp;
              router-link(:to="{ name: 'terms', hash: '#general-disclaimers' }") General Disclaimers
              | &nbsp;and&nbsp;
              router-link(:to="{ name: 'terms', hash: '#securities-matters' }") Securities Matters
              |  and for a more complete description of these investment risks click&nbsp;
              a(
                :href="require('doc/Acretrader-General-Risk-Statement.pdf')",
                target="_blank") here
              | .
            .copyright-wrap
              DisclaimerDisclosure(
                link-class="footer-link",
              )
                template(slot="linkName")
                  span Disclosures
              .is-h6__title.copyright(
              )
                span © {{ currentYear }}
                span  AcreTrader, Inc. All rights reserved.
</template>

<script>
import { CONTACTS } from 'Config/constans';
import { FOOTER_MENU } from 'Config/menu';
import FormSubscribeNewsletter from 'Components/FormSubscribeNewsletter/FormSubscribeNewsletter';
import DisclaimerDisclosure from 'Components/DisclaimerDisclosure/DisclaimerDisclosure';
import SolidEnvelopeIcon from 'images/svg-icons/solid-envelope.svg';
import SolidPhoneIcon from 'images/svg-icons/solid-phone.svg';
import SolidMapMarkerAltIcon from 'images/svg-icons/solid-map-marker-alt.svg';
import TheFooterMenu from './TheFooterMenu';
import TheFooterSocialLinks from './TheFooterSocialLinks';

export default {
  name: 'TheFooter',
  components: {
    FormSubscribeNewsletter,
    TheFooterMenu,
    DisclaimerDisclosure,
    SolidEnvelopeIcon,
    SolidPhoneIcon,
    SolidMapMarkerAltIcon,
    TheFooterSocialLinks,
  },
  data() {
    return {
      isMounted: false,
    };
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
  mounted() {
    this.isMounted = true;
  },
  staticData: {
    CONTACTS,
    menu: FOOTER_MENU,
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
footer
  background-color: $primary
  padding-top: 80px
  padding-bottom: 35px
  position: relative
  z-index: 2
  @media screen and (max-width: 767px)
    padding-top: 50px
  .left-wrap
    width: 100%
    @media screen and (max-width: 1130px)
      margin-right: 30px
    @media screen and (min-width: 1001px)
      max-width: 560px
    @media screen and (max-width: 1000px)
      margin-right: 0
  .right-wrap
    width: 100%
    @media screen and (min-width: 1001px)
      max-width: 488px
  .page-container
    justify-content: space-between
    @media screen and (max-width: 1000px)
      justify-content: center
      flex-wrap: wrap
  .location
    list-style-type: none
    padding-left: 0
    margin-top: 10px
    @media screen and (max-width: 1000px)
      margin-top: 50px
    @media screen and (max-width: 576px)
      margin-top: 40px
    li
      width: auto
      margin-bottom: 14px
    a
      font-family: $font-regular
      font-weight: 400
      line-height: 17px
      display: flex
      align-items: center
      .svg-icon
        background-color: $text_gray
        width: 14px
        height: 14px
        flex-shrink: 0
        font-size: 10px
        padding: 2px
        fill: $primary
        position: relative
        border-radius: 2px
        margin-right: 12px
        +mt(.3s)
        &:before
          position: absolute
          transform: translate(-50%, -50%)
          left: 50%
          top: 50%
      &:hover
        svg
          background-color: rgba(255,255,255, 0.8)
          +mt(.3s)
    a:not(.address)
      span
        +mt(.3s)
        border-bottom: solid 1px transparent
      &:hover
        border-bottom: solid 1px transparent
        span
          +mt(.3s)
          border-bottom: solid 1px #fff
    .address
      display: flex
      line-height: 24px
      align-items: baseline
      span
        font-family: $font-regular
        font-weight: 400
        span
          +mt(.3s)
          border-bottom: solid 1px transparent
      &:hover
        border-bottom: solid 1px transparent
        span
          span
            +mt(.3s)
            border-bottom: solid 1px #fff
  .subscribe-social
    display: flex
    flex-direction: column
    .form-row
      @media screen and (max-width: 991px)
        max-width: 600px
        margin: 0 auto
        width: 100%
      .is-h5__title
        margin-bottom: 0
      ::v-deep .hs-submit
        input
          background-color: #9d9c9c !important
          color: #fff !important
          height: 40px !important
          padding: 0 20px !important
          &:hover
            background-color: #9d9c9c!important
      ::v-deep .input
        input
          height: 40px !important
          outline: none
  .footer-bottom
    border-top: solid 1px $text_gray
    padding-top: 35px
    margin-top: 70px
    @media screen and (max-width: 767px)
      margin-top: 50px
    &-wrap
      display: flex
      justify-content: space-between
      flex-direction: column
    .footer-text
      align-items: flex-start
      font-size: 12px
      color: $text_gray
      width: 100%
      @media screen and (max-width: 767px)
        margin-right: 0
      a
        font-size: 12px
        line-height: 17px
        color: $text_gray !important
        &:hover
          text-decoration: none !important
    .copyright-wrap
      display: flex
      flex-direction: row
      justify-content: space-between
      margin-top: 15px
      @media screen and (max-width: 576px)
        align-items: center
    .copyright
      color: $white
      opacity: 0.1
      text-align: right
      line-height: 26px
      @media screen and (max-width: 767px)
        text-align: left
      @media screen and (max-width: 576px)
        width: 100%
        max-width: 183px
    ::v-deep .footer-link
      display: flex
      color: $text_gray !important
      font-size: 12px
      font-family: $font-semibold
      font-weight: 600
      line-height: 26px
</style>
